import { render, staticRenderFns } from "./WeetPlayerAnnotations.vue?vue&type=template&id=1223b6d7&scoped=true"
import script from "./WeetPlayerAnnotations.vue?vue&type=script&lang=ts"
export * from "./WeetPlayerAnnotations.vue?vue&type=script&lang=ts"
import style0 from "./WeetPlayerAnnotations.vue?vue&type=style&index=0&id=1223b6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223b6d7",
  null
  
)

export default component.exports